export class ScheduleFieldEntity {
    public static fromDto(dto: any): ScheduleFieldEntity {
        const entity = new ScheduleFieldEntity();
        entity.scheduleId = dto.scheduleId;
        entity.fieldNumber = dto.fieldNumber;
        entity.venueId = dto.venueId ?? null;
        return entity;
    }

    public static fromDtoArray(dtos: any[]): ScheduleFieldEntity[] {
        if (!dtos) { return []; }
        return dtos.map(d => ScheduleFieldEntity.fromDto(d));
    }

    public scheduleId: string = null;
    public fieldNumber: number = null;
    public venueId: string | null = null;
}
